// W-0829 — Wrapper Axios para o CRUD mestre/detalhe de Resultado de Atendimento (Cobrador).
// Fonte: UResultadoAtend.pas (TFResultadoAtend). Backend: cobrador/resultado-atendimento (sem "api/").
// Payload/querystring em snake_case (config global da API faz a ponte para PascalCase).
// Apenas GET/POST (ADR-011 — backend não expõe PUT/DELETE). Sem cache (cadastro mutável).

import { httpService } from '~/Services/Service';

const BASE = '/cobrador/resultado-atendimento';

// Tipos (mestre — tabela Atendimento, range 100..999)
// Omite params vazios: o backend aceita filtro ausente mas rejeita string vazia (filtro=) com 400 (W-0829-002).
export const listarTipos = (filtro, tipoBusca) =>
  httpService.get(`${BASE}/tipos`, {
    params: { filtro: filtro || undefined, tipo_busca: tipoBusca || undefined },
  });
export const inserirTipo = (data) => httpService.post(`${BASE}/tipos/inserir`, data); // { descricao, paga }
export const editarTipo = (data) => httpService.post(`${BASE}/tipos/editar`, data); // { codigo, descricao, paga }
export const excluirTipo = (codigo) => httpService.post(`${BASE}/tipos/excluir`, { codigo });

// SubTipos (detalhe — tabela Atendimento_SubTipo, PK composta (Codigo, CodAtendimento))
export const listarSubTipos = (codAtendimento) =>
  httpService.get(`${BASE}/tipos/${codAtendimento}/subtipos`);
export const inserirSubTipo = (data) => httpService.post(`${BASE}/subtipos/inserir`, data); // { cod_atendimento, descricao }
export const editarSubTipo = (data) => httpService.post(`${BASE}/subtipos/editar`, data); // { codigo, cod_atendimento, descricao }
export const excluirSubTipo = (data) => httpService.post(`${BASE}/subtipos/excluir`, data); // { codigo, cod_atendimento }
